/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import AVCInformation from "./avc_Information";
import AVCInformationText from "./avc_information_text";
import AvcInformation, { MvcInformation } from "./avc_mvc_information";
import { AiFillCloseCircle } from "react-icons/ai";
import {
  IoIosArrowDropleftCircle,
  IoIosArrowDroprightCircle,
} from "react-icons/io";
import Comments from "./comments";
import Moment from "moment";
import Loader from "react-loader-spinner";
import { toast } from "react-toastify";
import "./assign_to_me.css";
import S3 from "react-aws-s3";
import { apiEndPoint } from "../../../config";
import {
  sumitCases,
  s3Upload,
  sumitCasesAgre,
  getAllViolationReason,
  getPlazaNameType,
  getGazettePath,
  getGazette
} from "../../../common/apiService";

import { validateFileTypeAndSize } from "../../../service/utilService";
import AVCImageSelection from "./avc_image_selection";
import { FaFileDownload } from "react-icons/fa";


const { config } = apiEndPoint;
const { url } = apiEndPoint;

export default function CaseReviewScreenPopup(props) {
    const [currentIndex, setCurrentIndex] = useState();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [comments, setComments] = useState([]);
    const [change, setChange] = useState(false);
    const [enablesubmit, setEnableSubmit] = useState(false); 
    const [expiredcountdown, setExpiredCountDown] = useState(false);
    const [existingOtherImages, setExistingOtherImages] = useState([]);
    const [journeyType, setJourneyType] = useState("");
    const [focusevent, setFocus] = useState(false);
  const [vin, setVin] = useState("");
  const [noOfAxles, setNoOfAxles] = useState("");
  const [vehicleDescription, setVehicleDescription] = useState("");
  const [gvw, setGvw] = useState("");
  const [numberOfSeats, setNumberOfSeats] = useState("");
  const [seatingCapacityPlaza, setSeatingCapacityPlaza] = useState("");////change later
  const [seatingCapacityClass, setSeatingCapacityClass] = useState("");
  const [gazetteId, setGazetteId] = useState("");
  const [vahanClass, setVahanClass] = useState("");
  const [vahanClassDesc, setVahanClassDesc] = useState("");
  const [gvwAmount, setGvwAmount] = useState("");
  const [seatingCapacityAmount, setSeatingCapacityAmount] = useState("");
  const [gvwCaseDifferentialAmount, setGvwCaseDifferentialAmount]=useState("");
  const [avcAmount, setAvcAmount] = useState("");
  const [seatingCaseDifferentialAmount, setSeatingCaseDifferentialAmount] = useState("");
  const [violationBasedOn, setViolationBasedOn] = useState("");
    const [reasonList, setReasonList] = useState([]);
    const [violationReason, setViolationReason] = useState("");
    const [violationReasonNew, setViolationReasonNew] = useState("");


  useEffect(() => {
    setData([...props.parentGridData]);
    const flag = !change;
    setChange(flag);
    // eslint-disable-next-line
  }, [props.parentGridData]);

  useEffect(() => {
    setCurrentIndex(props.index);
    setData([...props.parentGridData]);
    setEnableSubmit(false);
    // eslint-disable-next-line
  }, [props.showModel]);

    useEffect(() => {

        console.log("changing reasoncd")
        console.log(violationReason)
        // eslint-disable-next-line
    }, [violationReason])

  const handleViolationReasonChange = (value) => {
    setViolationReason(value);
    setViolationReasonNew(value);
    console.log("handleViolationReasonChange 123"+value)
  };
  const keyDownEvent = (evt) => {
    if (focusevent === false && loading === false) {
      if (evt.key === "Escape") {
        props.setShowModel(false);
      }
      if (evt.key === "ArrowLeft") previousViolation();
      else if (evt.key === "ArrowRight") nextViolation();
    }
}


    document.onkeydown = keyDownEvent;

  const handleGazetteDownload = async (gazetteId) => {
    try {
      console.log("gazette iddd", gazetteId);

      //S3 path from DB
      const pathResponse = await getGazettePath(gazetteId);
      const gazettePath = pathResponse.data;
      console.log("s3 path", gazettePath);

      if (!gazettePath) {
        throw new Error("No S3 path found for gazetteId " + gazetteId);
      }

      // get pre-signed URL
      const response = await getGazette(gazettePath);

      if (response.status !== 200) {
        throw new Error(response.data || "Failed to get download link");
      }

      const presignedUrl = response.data;
      console.log("url", presignedUrl);

      // 3. Trigger browser download
      const link = document.createElement("a");
      link.href = presignedUrl;
      link.setAttribute("download", "");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Download failed:", error.message);
      toast.error("Could not download the gazette. Please try again.");
    }
  };

  useEffect(() => {
    if (!currentIndex && currentIndex != 0) return;
    if (data.length === 0) return;
    const e = data[currentIndex] || {};
    setCaseid(e.id);
    setRrnno(e.rrn);
    setPlazaid(e.plazaId);
    setTagid(e.tagId);
    settxnstatus(e.transactionStatus);
    setcasestatus(e.status);
    setreportingdatetime(e.readerReadTime);
    setVehicleClass(e.npciVehicleClass);
    setIssuerId(e.issuerId);
    setIssuerBankName(e.bankName);
    setDifferentialAmount(e.differentialAmount);
    settxnid(e.agencyTxnId);
    setrrdtime(e.readerReadTime);
    setAvcVehicleClass(e.mappedAvcDesc);
    setMvcVehicleClass(e.npciVcDesc);
    setRegNumber(e.regNumber);
    setMineralMajorFlag(e.mineralMajorFlag);
    setSrtlFlag(e.srtlFlag);
    setCaseType(e.adjustment);
    if (e.adjustment == "CA" || e.adjustment == "Manual CA") {
      //setFareamount(e.settlementAmount - e.differentialAmount);
      setFareamount(e.avcAmount);
    } else {
      setFareamount(e.avcAmount);
    }
    setSettlementAmount(e.settlementAmount);
    setMlStatus(e.mlStatus);
    setPlazaAvc(e.plazaAvc);
    setWideRangeImageName(e.wideRangeImageName);
    setRearViewImageName(e.rearViewImageName);
    setRemark(e.remark);
    setExistingOtherImages(e.otherImages || []);
    setJourneyType(e.journeyType);
    setEntryTollPlazaId(e.entryTollPlazaId);
        setViolationReason(e.violationReasonCd);
    const etacountdown = props.etaArray;
    if (etacountdown && etacountdown.length > 0) {
      const timer = etacountdown[currentIndex];
      setTimeout(() => setExpiredCountDown(timer === "Expired"), 100);
    }
    //console.log(data);
    setViolationType(e.source);

    //fetch plaza Type, name
    getPlazaNameType(e.plazaId)
      .then((res) => {
        if (res?.data) {
          setPlazaName(res.data.plazaName);
          setPlazaType(res.data.plazaSubType);
          setPlazaSubType(res.data.plazaType);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch plaza info", err);
      });
      setVin(e.vin);
      setNoOfAxles(e.noOfAxles);
      setVehicleDescription(e.vehicleDescription);
      setGvw(e.gvw);
      setNumberOfSeats(e.numberOfSeats);
      setSeatingCapacityPlaza(e.seatingCapacityPlaza);
      setSeatingCapacityClass(e.seatingCapacityClass);
      setGazetteId(e.gazetteId);
      setVahanClass(e.gvwMappedClass);
      setVahanClassDesc(e.gvwMappedClassDesc);
      setGvwAmount(e.gvwAmt);
      setSeatingCapacityAmount(e.seatingCapacityAmt);
      setGvwCaseDifferentialAmount(e.gvwCaseDifferentialAmount);
      setSeatingCaseDifferentialAmount(e.seatingCaseDifferentialAmount);
      setViolationBasedOn(e.differentialAmountType);

    setTimeout(() => setLoading(false), 300);
  }, [currentIndex, change, data, props.etaArray]);

  const [caseid, setCaseid] = useState("");
  const [dateformat] = useState("D MMMM'YY, hh:mm A");
  const [rrnno, setRrnno] = useState(0);
  const [plazaid, setPlazaid] = useState(0);
  const [claimedAvc, setClaimedAvc] = useState("");
  const [tagid, setTagid] = useState("");
  const [txnid, settxnid] = useState("");
  const [txnstatus, settxnstatus] = useState("");
  const [newDiffAmt, setNewDiffAmt] = useState(0);
  const [casestatus, setcasestatus] = useState("");
  const [caseType, setCaseType] = useState("");
  const [entryTollPlazaId, setEntryTollPlazaId] = useState("");
  const [rrdtime, setrrdtime] = useState("");
  const [avcVehicleClass, setAvcVehicleClass] = useState("");
  const [mvcVehicleClass, setMvcVehicleClass] = useState("");
  const [reportingdateandtime, setreportingdatetime] = useState("");
  const [vehicleClass, setVehicleClass] = useState("");
  const [issuerId, setIssuerId] = useState("");
  const [issuerBankName, setIssuerBankName] = useState("");
  const [regNumber, setRegNumber] = useState("");
  const [fareamount, setFareamount] = useState("");
  const [differentialAmount, setDifferentialAmount] = useState("");
  const [settlementAmount, setSettlementAmount] = useState("");
  const [mlStatus, setMlStatus] = useState("");
  const [remark, setRemark] = useState("");
  const [plazaAvc, setPlazaAvc] = useState("");
  const [wideRangeImageName, setWideRangeImageName] = useState();
  const [rearViewImageName, setRearViewImageName] = useState();
  const [newFrontImageName, setNewFrontImageName] = useState("");
  const [newBackImageName, setNewBackImageName] = useState("");
  const [mineralMajorFlag, setMineralMajorFlag] = useState("");
  const [srtlFlag, setSrtlFlag] = useState("");
  const [violationType, setViolationType] = useState("");
  const [plazaName, setPlazaName] = useState("");
  const [plazaType, setPlazaType] = useState("");
  const [plazaSubType, setPlazaSubType] = useState("");


  const previousViolation = () => {
    setNewBackImageName("");
    setNewFrontImageName("");
    if (currentIndex > 0) {
      setLoading(true);
      setCurrentIndex(currentIndex - 1);
    } else {
      if (props.currentPage > 0) {
        setLoading(true);
        props.setCurrentPage(props.currentPage - 1);
        setCurrentIndex(9);
      }
    }
  };

  const nextViolation = () => {
    setNewBackImageName("");
    setNewFrontImageName("");
    if (currentIndex < data.length - 1) {
      setLoading(true);
      setCurrentIndex(currentIndex + 1);
    } else {
      if (props.totalPage > props.currentPage + 1) {
        setLoading(true);
        props.setCurrentPage(+props.currentPage + 1);
        setCurrentIndex(0);
      }
    }
  };

  //S3 bucket code
  const [uploadStatus, setUploadStatus] = useState(false);
  const frontimageInput = useRef();
  const backImageInput = useRef();
  const ReactS3 = new S3(config);

  const uploadFrontImageToS3Bucket = (input) => {
    uploadImage(input, wideRangeImageName);
  };

  const uploadBackImageToS3Bucket = (input) => {
    uploadImage(input, rearViewImageName);
  };

  const uploadOtherImageToS3Bucket = (inputArr) => {
    for (let i = 0; i < inputArr.length; i++)
      uploadImage({ current: { files: [inputArr[i]] } }, "");
  };

  const uploadImage = (input, orignalName) => {
    if (input.current.files.length > 0 && input.current.files[0]) {
      const image = input.current.files[0];
      const name = input.current.files[0].name;
      setLoading(true);
      const blob = image.slice(0, image.size, "image/jpg");
      const newFile = new File([blob], name, { type: "image/jpg" });
      const formdata = new FormData();
      formdata.append("file", newFile);
      for (let i = 0; i < image.length; i++) {
        formdata.append("file", image[i]);
      }

      s3Upload(formdata)
        .then((res) => {
          setUploadStatus(true);
          toast.success("Success upload " + name + " image");
          removeViolationByIndex();
          setEnableSubmit(false);
          setLoading(false);
        })
        .catch((err) => {
          toast.warning("Something goes wrong!");
          setEnableSubmit(true);
          setLoading(false);
        });
      let el = document.getElementById(orignalName + "upload-images");
      if (el) el.value = "";
    }
  };
  const removeViolationByIndex = () => {
    if (props.etaArray)
      props.setEtaArray(props.etaArray.filter((e, i) => i !== currentIndex));
    props.setParentGridData(
      props.parentGridData.filter((e, i) => i !== currentIndex)
    );
    props.setTotalGridData((old) => old - 1);
    if (props.parentGridData.length - 1 === currentIndex) {
      nextViolation();
      if (currentIndex < data.length - 1) {
      } else {
        setLoading(true);
        if (props.totalPage > props.currentPage + 1) {
          setLoading(true);
          props.setCurrentPage(+props.currentPage + 1);
          setCurrentIndex(0);
        } else {
          if (data.length === 1) {
            previousViolation();
            toast.info("No Data Found on current page!");
            props.setShowModel(false);
          } else {
            if (currentIndex !== 0) setCurrentIndex(currentIndex - 1);
          }
        }
      }
    }
  };

  // on image selection display image funnction call for dislay image in block
  const displayImage = (id) => {
    setEnableSubmit(true);
    let input = frontimageInput;
    if (id === "back") input = backImageInput;
    if (input.current.files && input.current.files[0]) {
      const valid = validateFileTypeAndSize(input.current.files, "image", 5);
      if (valid) {
        var reader = new FileReader();
        reader.onload = function (e) {
          document.getElementById(id).setAttribute("src", e.target.result);
          let data = [...imgurl];
          if (data.length > 1) {
            if (imgurl.length - 1 === selectedImageIndex[0]) {
              if (id === "front") {
                data[selectedImageIndex[1]] = e.target.result;
              } else {
                data[selectedImageIndex[0]] = e.target.result;
              }
            } else {
              if (id === "front") {
                data[selectedImageIndex[0]] = e.target.result;
              } else {
                data[selectedImageIndex[1]] = e.target.result;
              }
            }
          } else {
            if (id === "front") data[selectedImageIndex[0]] = e.target.result;
            if (id === "back") data[selectedImageIndex[1]] = e.target.result;
          }
          setImgUrl(data);
        };
        reader.readAsDataURL(input.current.files[0]);
        const bimgname = [...otherImagesName];
        const bimg = [...otherImages];
        if (id === "back") {
          setNewBackImageName(input.current.files[0].name);
          bimgname[selectedImageIndex[1]] = input.current.files[0].name;
          bimg[selectedImageIndex[1]] = input.current.files[0];
        } else {
          setNewFrontImageName(input.current.files[0].name);
          bimgname[selectedImageIndex[0]] = input.current.files[0].name;
          bimg[selectedImageIndex[0]] = input.current.files[0];
        }
        setOtherImagesName(bimgname);
        setOtherImages(bimg);
      }
    }
  };
  //end s3 bucket

  const setNewClaimedAVC = (claimedAvc1) => {
    setClaimedAvc(claimedAvc1);
    //console.log(claimedAvc1)
  };
  const setNewDisputeAmt = (diffAmt) => {
    setNewDiffAmt(diffAmt);
    //console.log(diffAmt)
  };

  const submitViolation = () => {
    // Case submit/reopen when user not change something (front/back/OtherImages)
    // only for Submit case not for uploading image to S3
    if (
      !newFrontImageName &&
      !newBackImageName &&
      otherImagesName?.length === existingOtherImages?.length
    ) {
      const headerJson = {};
      // set all blank when submit/Reopen without any change in images
      //console.log(" ---"+claimedAvc)
      const newAVC =
        caseType && caseType === "Fare rule not available" && claimedAvc
          ? claimedAvc
          : null;
      //console.log(" --caseType-"+caseType +"-----claimedAvc-"+claimedAvc+"-----newAVC-"+newAVC+"---newDiffAmt-"+newDiffAmt)
      if (caseType === "Fare rule not available" && newAVC) {
        if (newDiffAmt != null && newDiffAmt < 1) {
          toast.warn("Raised Dispute Can Not less than 1!");
          return;
        }
      } else if (caseType === "Fare rule not available" && !newAVC) {
        toast.warn("Select New Concessionaire Vehicle Class!");
        return;
      }
            var submitReason = violationReason;
            if(violationReasonNew!=""){
            submitReason=violationReasonNew;
            }

      const bodyJson = {
        caseId: caseid,
        wideRangeImageName: null,
        rearViewImageName: null,
        otherImagesName: [],
        claimedAvc: newAVC,
        newDiffAmt: newDiffAmt,
                violationReasonCd: submitReason,
      };
      sumitCases(headerJson, bodyJson, remark)
        .then((res) => {
          resetAfterSubmit();
          toast.success("Successfully Submitted!");
          removeViolationByIndex();
        })
        .catch((err) => {
          const errorMessage =
            err.response?.data?.Error || "Something went wrong!";
          if (caseType === "Fare rule not available") {
            toast.warning(errorMessage);
            return;
          }
        });
    } else {
      let otherImg = [...otherImages];
      // If user select Back image from top
      if (backImageInput.current?.files?.length > 0) {
        uploadBackImageToS3Bucket(backImageInput);
        otherImg.splice(1, 1);
        otherImagesName.splice(1, 1);
      }

      // If user select Front image from top
      if (frontimageInput.current?.files?.length > 0) {
        uploadFrontImageToS3Bucket(frontimageInput);
        otherImg.splice(0, 1);
        otherImagesName.splice(0, 1);
      }
      setOtherImagesName(otherImagesName);
      uploadOtherImageToS3Bucket(otherImg);
    }
  };

  const agree = () => {
    const headerJson = {};
    const bodyJson = {
      caseId: caseid,
    };
    sumitCasesAgre(headerJson, bodyJson);
    toast.success("Successfully Submitted!");
    removeViolationByIndex();
  };

  useEffect(() => {
    if (uploadStatus) {
      var imgflag = 0;

      const newAVC =
        caseType && caseType === "Fare rule not available" && claimedAvc
          ? claimedAvc
          : null;
      //console.log(" --caseType-"+caseType +"-----claimedAvc-"+claimedAvc+"-----newAVC-"+newAVC+"---newDiffAmt-"+newDiffAmt)
      if (caseType === "Fare rule not available" && newAVC) {
        if (newDiffAmt != null && newDiffAmt < 1) {
          toast.warn("Raised Dispute Can Not less than 1!");
          imgflag = 1;
        }
      } else if (caseType === "Fare rule not available" && !newAVC) {
        toast.warn("Select New Concessionaire Vehicle Class!");
        imgflag = 1;
      }
      if (imgflag === 0) {
        const headerJson = {};
                var submitReason = violationReason;
                            if(violationReasonNew!=""){
                            submitReason=violationReasonNew;
                            }
        const bodyJson = {
          caseId: caseid,
          wideRangeImageName: newFrontImageName || null,
          rearViewImageName: newBackImageName || null,
          otherImagesName: otherImagesName.filter(Boolean),
          claimedAvc: newAVC,
          newDiffAmt: newDiffAmt,
                    violationReasonCd: submitReason,
        };
        sumitCases(headerJson, bodyJson, remark)
          .then((res) => {
            //resetAfterSubmit();

            if (caseType === "Fare rule not available") {
              toast.success("Successfully Submitted!");
              //removeViolationByIndex();
            }
          })
          .catch((err) => {
            const errorMessage =
              err.response?.data?.Error || "Something went wrong!";
            if (caseType === "Fare rule not available") {
              toast.warning(errorMessage);
            }
          });
                console.log("calling reset submit 1")
        resetAfterSubmit();
        setTimeout(() => setUploadStatus(false), 1200);
      }
    }
    // eslint-disable-next-line
  }, [uploadStatus]);

  const handleLanguage = (langValue) => {
    setFocus(langValue);
  };

  const resetAfterSubmit = () => {
    const el = document.getElementById("ml-upload-image");
    if (el) el.value = "";
    setNewBackImageName("");
    setNewFrontImageName("");
    setOtherImages([]);
    setOtherImagesName([]);
    setImgUrl([]);
    setSelectedImageIndex([0, 1]);
    setClaimedAvc("");;
    setNewDiffAmt(0);;
        console.log("Calling reset after submit")
       // setViolationReason("");
  };

  useEffect(() => {
    // Get image names directly from data[currentIndex] to avoid race conditions
    if (currentIndex !== undefined && data.length > 0) {
      const row = data[currentIndex];
      const frontImg = row?.wideRangeImageName;
      const backImg = row?.rearViewImageName;
      
      const front = frontImg?.split("//")[1]?.split("/") || [];
      front.shift();
      const back = backImg?.split("//")[1]?.split("/") || [];
      back.shift();
      
      const frontname =
        url + "/toll/violation/download?fileName=" + encodeURIComponent(front.join("/"));
      const backname =
        url + "/toll/violation/download?fileName=" + encodeURIComponent(back.join("/"));
      
      const arr = [frontname, backname];
      const otherImgName = row.otherImages;
      if (otherImgName) {
        setOtherImagesName(otherImgName);
        let oImgArr = [];
        otherImgName.forEach((e) => {
          let name = e?.split("//")[1]?.split("/") || [];
          name.shift();
          oImgArr.push(
            url + "/toll/violation/download?fileName=" + encodeURIComponent(name.join("/"))
          );
        });
        setImgUrl([...arr, ...oImgArr]);
      } else {
        setImgUrl(arr);
      }
    }
  }, [currentIndex, data]);

  const [selectedImageIndex, setSelectedImageIndex] = useState([0, 1]);
  const [otherImages, setOtherImages] = useState([]);
  const [otherImagesName, setOtherImagesName] = useState([]);
  const [imgurl, setImgUrl] = useState([]);

  // on image selection display image funnction call for dislay image in array
  const displayImageOther = (e) => {
    if (imgurl.length + +e.target.files.length > 5) {
      toast.warning("You can only upload a maximum of 5 files");
      return;
    }
        const valid = validateFileTypeAndSize(e.target.files, "image", 5);
        if (!valid) {
        console.log('image not valid')
            const el = document.getElementById("ml-upload-image");
            if (el) el.value = "";
            return;
        }

    if (e.target.files.length > 0) {


      const imgs = e.target.files;
      setOtherImages([...otherImages, ...imgs]);

      let arr = [];
      let nameArr = [];
      for (let i = 0; i < imgs.length; i++) {
        arr.push(URL.createObjectURL(imgs[i]));
        nameArr.push(imgs[i].name);
      }
      setImgUrl([...imgurl, ...arr]);
      setOtherImagesName([...otherImagesName, ...nameArr]);
      if (imgurl.length === 0) {
        setNewFrontImageName(nameArr[0]);
        setNewBackImageName(nameArr[1]);
      } else if (imgurl.length === 1) {
        if (newBackImageName) setNewFrontImageName(nameArr[0]);
        if (newFrontImageName) setNewBackImageName(nameArr[0]);
      }
    }
    setTimeout(() => {
      document.getElementById("preview-image0")?.click();
    }, 10);


  };

  const removeImage = (imgIndex) => {
    const newData = [...imgurl];
    newData.splice(imgIndex, 1);
    setImgUrl(newData);

    const imgName = [...otherImagesName];
    imgName.splice(imgIndex, 1);
    setOtherImagesName(imgName);

    const img = [...otherImages];
    img.splice(imgIndex, 1);
    setOtherImages(img);
  };
  /* End handling of new feature */

  return (
    <>
      <Modal
        className="fullscreenmodal approverejectpop case-reviewpopup"
        show={props.showModel}
        onHide={() => props.setShowModel(false)}
        size="lg"
        centered
      >
        <Modal.Header className="modalheader">
          <Modal.Title>
            <span className="modaltitle">RRN Number -</span>
            <span className="rrnnumber">{rrnno}</span>
          </Modal.Title>
          <AiFillCloseCircle
            className="closebtn"
            onClick={() => props.setShowModel(false)}
          />
        </Modal.Header>
        <Modal.Body className="modelbody">
          <Loader
            className="loader"
            type="ThreeDots"
            color="#9c1d26"
            height={100}
            width={100}
            visible={loading}
          />
          {!loading && (
            <>
              {" "}
              <IoIosArrowDropleftCircle
                className="arrowbtn"
                id="leftarrowbtn"
                onClick={previousViolation}
              />
              <IoIosArrowDroprightCircle
                className="arrowbtn"
                id="rightarrowbtn"
                onClick={nextViolation}
              />
            </>
          )}
           <div className="body-title violation-info flex flex-wrap gap-4">
            <div>
              <div className="body-title-label violation-info-label">
                {" "}
                Plaza ID{" "}
              </div>
              <div className="body-title-value violation-info-value">
                {plazaid}
              </div>
            </div>
            <div>
              <div className="body-title-label violation-info-label">
                {" "}
                Plaza Name{" "}
              </div>
              <div className="body-title-value violation-info-value">
                {plazaName}
              </div>
            </div>
            <div>
              <div className="body-title-label violation-info-label">
                {" "}
                Plaza Type{" "}
              </div>
              <div className="body-title-value violation-info-value">
                {`${plazaType} / ${plazaSubType}`}
              </div>
            </div>
            <div>
              <div className="body-title-label violation-info-label">
                {" "}
                Tag ID{" "}
              </div>
              <div className="body-title-value violation-info-value">
                {tagid}
              </div>
            </div>
            <div>
              <div className="body-title-label violation-info-label">
                {" "}
                Txn ID{" "}
              </div>
              <div className="body-title-value violation-info-value">
                {txnid}
              </div>
            </div>
            <div>
              {" "}
              <div className="body-title-label violation-info-label">
                {" "}
                Txn Status{" "}
              </div>
              <div className="body-title-value violation-info-value">
                {txnstatus}
              </div>
            </div>
            <div>
              <div className="body-title-label violation-info-label">
                {" "}
                Processing Time
              </div>
              <div className="body-title-value violation-info-value">
                {Moment.utc(reportingdateandtime).format(dateformat)}
              </div>
            </div>
            <div>
              <div className="body-title-label violation-info-label">
                {" "}
                Violation Type{" "}
              </div>
              <div className="body-title-value violation-info-value">
                {violationType}
              </div>
            </div>
            <div>
              <div className="body-title-label violation-info-label">
                {" "}
                Vahan Class{" "}
              </div>
              <div className="body-title-value violation-info-value">
                {vahanClass}
              </div>
            </div>
            <div>
              <div className="body-title-label violation-info-label"> GVW </div>
              <div className="body-title-value violation-info-value">{gvw}</div>
            </div>
            <div>
              <div className="body-title-label violation-info-label">
                {" "}
                Vehicle Description{" "}
              </div>
              <div className="body-title-value violation-info-value">
                {vehicleDescription}
              </div>
            </div>
            <div>
              <div className="body-title-label violation-info-label">
                {" "}
                No of Axles{" "}
              </div>
              <div className="body-title-value violation-info-value">
                {noOfAxles}
              </div>
            </div>
            {seatingCapacityPlaza && (
              <>
                
                <div>
                  <div className="body-title-label violation-info-label">
                    Seating Capacity Amount
                  </div>
                  <div className="body-title-value violation-info-value">
                    {seatingCapacityAmount}
                  </div>
                </div>

                <div>
                  <div className="body-title-label violation-info-label">
                    Number of Seats
                  </div>
                  <div className="body-title-value violation-info-value">
                    {numberOfSeats}
                  </div>
                </div>
                <div>
                  <div className="body-title-label violation-info-label">
                    Seating Capacity Class
                  </div>
                  <div className="body-title-value violation-info-value">
                    {seatingCapacityClass}
                  </div>
                </div>

                <div>
                  <div className="body-title-label violation-info-label">
                    Gazette
                  </div>
                  <div className="body-title-value violation-info-value">
                    {gazetteId ? (
                      <FaFileDownload
                        style={{
                          fontSize: 20,
                          cursor: "pointer",
                          color: "grey",
                          marginLeft: "8px",
                        }}
                        onClick={() => handleGazetteDownload(gazetteId)}
                      />
                    ) : (
                      "--"
                    )}
                  </div>
                </div>
              </>
            )}
            <div>
              <div className="body-title-label violation-info-label">
                {" "}
                Vahan Class Description{" "}
              </div>
              <div className="body-title-value violation-info-value">
                {vahanClassDesc}
              </div>
            </div>
            <div>
              <div className="body-title-label violation-info-label">
                {" "}
                GVW Amount{" "}
              </div>
              <div className="body-title-value violation-info-value">
                {gvwAmount}
              </div>
            </div>
          </div>

          <div className="information">
            <div
              style={{
                marginLeft: 0,
                padding: "0px 18px",
                borderRight: "1px solid lightgray",
              }}
            >
              <span className="infolabel">Captured images :</span>
              <br />
              <span style={{ fontSize: 12, color: "#707070" }}></span>
              <div className="vehicleimg ">
                <div className="dislayflex">
                  <div>
                    <AVCInformation
                      key={`front-${currentIndex}`}
                      src={wideRangeImageName}
                      side="front"
                      readerReadTime={Moment.utc(rrdtime).format(dateformat)}
                      imageInput={frontimageInput}
                      displayImage={displayImage}
                      actionperform={props.actionperform}
                      setEnableSubmit={setEnableSubmit}
                    />
                  </div>
                  <div>
                    <AVCInformation
                      key={`back-${currentIndex}`}
                      src={rearViewImageName}
                      side="back"
                      readerReadTime={Moment.utc(rrdtime).format(dateformat)}
                      imageInput={backImageInput}
                      displayImage={displayImage}
                      actionperform={props.actionperform}
                      setEnableSubmit={setEnableSubmit}
                    />
                  </div>
                </div>
                <AVCImageSelection
                  key={`thumbnails-${currentIndex}`}
                  displayImageOther={displayImageOther}
                  imgurl={imgurl}
                  removeImage={removeImage}
                  setSelectedImageIndex={setSelectedImageIndex}
                  selectedImageIndex={selectedImageIndex}
                />

                <AVCInformationText
                  issuerId={issuerId}
                  issuerBankName={issuerBankName}
                  vehicleclass={avcVehicleClass}
                  differentialAmount={differentialAmount}
                  readerReadTime={Moment.utc(rrdtime).format(dateformat)}
                  seatingCapacityEnabled = {!!seatingCapacityPlaza}
                    seatingCaseDifferentialAmount={
                      seatingCaseDifferentialAmount
                    }
                    gvwCaseDifferentialAmount={gvwCaseDifferentialAmount}
                    avcAmount={fareamount - settlementAmount}
                    violationBasedOn={violationBasedOn}
                />
              </div>
            </div>
            <div style={{ marginRight: 0 }} className="rightdiv">
              <div class="dislayflex">
                <AvcInformation
                  id="fist"
                  title="AVC Information"
                  vehicletype={avcVehicleClass}
                  vechicleclass={plazaAvc}
                  regno={regNumber}
                  fareamount={fareamount}
                  srtlFlag={srtlFlag}
                  mineralMajorFlag={mineralMajorFlag}
                  plazaId={plazaid}
                  setNewClaimedAVC={setNewClaimedAVC}
                  setNewDiffAmt={setNewDisputeAmt}
                  claimedAvc={claimedAvc}
                  entryTollPlazaId={entryTollPlazaId}
                  vcClass={vehicleClass}
                  settleAmt={settlementAmount}
                  readerReadTime={rrdtime}
                  caseType={caseType}
                                    violationReasonCd={violationReason}
                                    onValueChange={handleViolationReasonChange}
                                    caseStatus={casestatus}
                                    commentsl={comments}
                                    actionperforml={props.actionperform}

                />
                <MvcInformation
                  id="second"
                  title="MVC Information"
                  journeyType={journeyType}
                  vechicleclass={mvcVehicleClass}
                  regno={regNumber}
                  settlementAmount={settlementAmount}
                  srtlFlag={srtlFlag}
                  mineralMajorFlag={mineralMajorFlag}
                />
              </div>
              <div style={{ padding: "0 18px" }}>
                {remark ? (
                  <div className="dislayflex">
                    <span className="caseprediction">
                      IDFC Remark: {remark}
                    </span>
                    {/* <span className="idfc-remark-value">Wrong Image</span> */}
                  </div>
                ) : null}
                <div className="comment-scrollarea">
                  <Comments
                    onSelectLanguage={handleLanguage}
                    plaza_id={plazaid}
                    case_id={caseid}
                    vehicleClass={vehicleClass}
                    focu={focusevent}
                    setComments={setComments}
                  />
                </div>
                {props.actionperform && (
                  <>
                    <br />
                    {casestatus != "Reject" ? (
                      <div className="upload-popup-btns1">
                        {expiredcountdown ? (
                          <div className="eta_expire_msg">
                            {" "}
                            ETA time has been expired to take any action!{" "}
                          </div>
                        ) : (
                          <div>
                            <button
                              style={{ width: "260px" }}
                              disabled={false}
                              onClick={agree}
                            >
                              Agree with IDFC FIRST
                            </button>{" "}
                            <button
                              disabled={
                                !enablesubmit && remark === "Image Not Found"
                              }
                              onClick={submitViolation}
                            >
                              Submit
                            </button>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className="upload-popup-btns1">
                        {expiredcountdown ? (
                          <div className="eta_expire_msg">
                            {" "}
                            ETA time has been expired to take any action!
                          </div>
                        ) : (
                          <div style={{ textAlign: "right" }}>
                            {" "}
                            <button
                              style={{ width: "260px" }}
                              disabled={false}
                              onClick={agree}
                            >
                              Agree with IDFC FIRST
                            </button>{" "}
                            {comments.length > 0 ? (
                              <button
                                disabled={false}
                                onClick={submitViolation}
                              >
                                Reopen
                              </button>
                            ) : (
                              <p
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                  color: "#9E2525",
                                }}
                              >
                                Please Enter Comment to Reopen Case
                              </p>
                            )}
                          </div>
                        )}
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

CaseReviewScreenPopup.defaultProps = {
  actionperform: true,
};
